import React from 'react'
import className from 'classnames'
import * as style from './modal-success.module.scss'
import ButtonPrimary from '../../buttons/ButtonPrimary'

const ModalFormSuccess = () => {
  const ulr = 'https://meetings.hubspot.com/k-nyzhehorodtseva'

  return (
    <div className={style.thanks}>
      <div className={style.container}>
        <p className={style.title}>Greetings!</p>
        <p className={style.subtitle}>Thanks for your message.</p>
        <p className={className(style.subtitle, style.subtitleMd)}>
          We&apos;ll get back to you within the next 12 hours.
        </p>
        <div className={style.additional}>
          <p className={style.description}>
            Additionally, you can pick the best time for a call with our experts
            right away
          </p>
        </div>
        <a href={ulr} target="_blank" rel="noreferrer">
          <ButtonPrimary btnClass={style.button}>Set Up Meeting</ButtonPrimary>
        </a>
      </div>
    </div>
  )
}

export default ModalFormSuccess
